/**
 * Given data, return objects with type 'group'.
 *
 * @param {array} array - array of results.
 * @returns {array} array of group results.
 */
export default function getResultsGroups(array) {
  // Return empty array if array
  // is not an array or array has no length.
  if (! Array.isArray(array) || 0 === array.length) {
    return [];
  }
  // Return 'group' objects from array.
  return array.filter((item) => 'group' === item.type);
}
